export default __webpack_public_path__ + "static/media/Group 24.12e0ec10.png";